import { atom } from "jotai"
import { VisualEncodingProps } from "./types"

export const strokeScaleState = atom<VisualEncodingProps>({})
